import { render, staticRenderFns } from "./classificationdialog.vue?vue&type=template&id=a6d98814&scoped=true"
import script from "./classificationdialog.vue?vue&type=script&lang=js"
export * from "./classificationdialog.vue?vue&type=script&lang=js"
import style0 from "./classificationdialog.vue?vue&type=style&index=0&id=a6d98814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d98814",
  null
  
)

export default component.exports